import * as React from "react";
import AuthUI from "@components/common/authUI";
import Modal from "@components/common/modal";
import { Text } from "@uikit";
import { useApp } from "@store/app";
import { ProviderT } from "@models/common";
import { useDocument } from "@hooks/useDocument";

interface IProps {
  onClose?: () => void;
  onSignIn?: () => void;
  visible?: boolean;
  defaultMode:
    | "login"
    | "checkout"
    | "signup"
    | "forgot"
    | "home"
    | "manage"
    | "check";
}

const LoginSignUp = ({ onClose, visible, onSignIn, defaultMode }: IProps) => {
  const doc = useDocument();
  const currentUrl = useApp(($) => $.currentUrl);
  const hideModals = useApp(($) => $.hideModals);
  const [mode, setMode] = React.useState<ProviderT>(defaultMode || "home");

  const getTitle = () => {
    switch (mode) {
      case "google":
        return "Log in with Google";
      case "facebook":
        return "Log in with Facebook";
      case "linkedin":
        return "Log in with LinkedIn";
      case "login":
        return "Log in";
      case "signup":
        return "Finish signing up";
      case "forgot":
        return "Reset your password";
      case "checkout":
        return "Checkout";
      case "check":
        return "Check your email";
      default:
        return "Sign up or Log in";
    }
  };

  const getAuthUI = React.useMemo(() => {
    return (
      <>
        <AuthUI
          redirectUrl={currentUrl}
          mode={mode}
          onModeChange={(mode) => {
            setMode(mode);
          }}
          onSignIn={() => {
            if (onSignIn) {
              setMode("home");
              hideModals();
              onSignIn();
            }
          }}
        />
      </>
    );
  }, [mode, currentUrl]);

  return (
    <Modal
      visible={visible}
      fullScreenMobile
      maxWidth="430px"
      title={getTitle()}
      showBackButton={mode !== "home" && mode !== "checkout"}
      onBack={() => {
        switch (mode) {
          case "forgot":
            setMode("login");
            break;
          default:
            setMode("home");
        }
      }}
      onClose={() => {
        if (onClose) {
          onClose();
        } else {
          hideModals();
        }

        //wait 1 second before resetting mode
        setTimeout(() => {
          setMode(defaultMode || "home");
        }, 1000);
      }}
    >
      {mode === "home" && (
        <>
          <img
            alt="Sign Up"
            src={`${process.env.GATSBY_IMAGE_PREFIX}/website/signup_img.jpg?auto=format,compress&dpr=1&quality=70`}
            className="w-full"
          />
        </>
      )}
      <div className=" px-7 py-6 ">
        {mode === "home" && (
          <div className="pb-2 flex flex-col gap-2 text-center justify-center">
            <Text
              element="h2"
              size={21}
              align="center"
              leading={1}
              weight="semibold"
              color="black90"
              className="!text-center"
            >
              Get the full experience
            </Text>

            <Text
              element="p"
              size={15}
              leading={1.5}
              color="black80"
              className="text-center"
            >
              Save your favourites, enjoy speedy checkout, and get access to
              member-only deals.
            </Text>
          </div>
        )}
        {getAuthUI}
      </div>
    </Modal>
  );
};

export default LoginSignUp;
